// This component has been autogenerated with 'generate:components' script
import type { IconProps } from 'icons/types/Icon.types'
import { DEFAULT_ICON_COLOR, DEFAULT_ICON_SIZE } from 'icons/utils/constants'
import { cx } from 'utils/cx'

import styles from 'icons/Icon.module.scss'

export const IconMarkerL = ({
	alt,
	className,
	color = DEFAULT_ICON_COLOR,
	height = DEFAULT_ICON_SIZE,
	lang,
	width = DEFAULT_ICON_SIZE,
	rotateRtl,
}: IconProps): React.ReactNode => {
	const computedClassName = cx(
		styles[`icon-${color}`],
		rotateRtl && styles['rotate-rtl'],
		className
	)

	return (
		<svg
			width={width}
			height={height}
			aria-hidden={alt ? undefined : 'true'}
			className={computedClassName}
			data-testid='marker-l'
			xmlns='http://www.w3.org/2000/svg'
		>
			{alt && <title lang={lang}>{alt}</title>}
			<path
				fill='#131313'
				d='M1.95 11.17C5.36 4.385 12.447 0 20 0c7.556 0 14.642 4.384 18.05 11.17 3.7 7.362 2.071 16.85-4.356 25.385-.164.247-12.505 18.67-12.505 18.67L20.001 57l-1.189-1.774S6.472 36.802 6.268 36.502c-6.387-8.482-8.017-17.97-4.317-25.331'
			/>
			<path
				fill='#fff'
				stroke='#fff'
				d='M25.893 13.5H28.5v14h-2V16.781l-.934 1.634-2.07 3.621-1.319-2.051zM13.5 18.508V27.5h-2v-14h2.232l7.682 11.522-1.136 2.021-5.862-8.812-.916-1.377z'
			/>
		</svg>
	)
}
